import React from "react";
import { IconButton, TextField } from "@origin-digital/ods-core";
import { IconCloseCircle, IconSearch } from "@origin-digital/ods-icons";
import { SearchFieldProps } from "./types";

export const SearchFieldBelowMd = ({
  searchInput,
  setSearchInput,
  "data-id": dataId = "searchField",
}: SearchFieldProps) => {
  return (
    <TextField
      id="search"
      placeholder="Search"
      aria-label="Search"
      size="small"
      startIcon={<IconSearch color="grey300" size="xsmall" />}
      endIcon={
        searchInput === "" ? null : (
          <IconButton
            noIconPadding
            onClick={() => setSearchInput("")}
            data-id={`${dataId}.clearButton`}
          >
            <IconCloseCircle variant="solid" color="grey300" size="xsmall" />
          </IconButton>
        )
      }
      hideHelperTextSpace
      value={searchInput}
      onChange={(e) => setSearchInput(e.target.value)}
      data-id={dataId}
    />
  );
};
